export class PatientQueue {
    patientQueueId: number;
    appointmentId: number;
    createdBy: number;
    token: string;
    status: string;
    createdDate: Date;
    providerName: string;
}
